import {is_defined} from './simple.functions';

/**
 * removes all items with value of deleteValue from the array
 *
 * @param deleteValue default: "" (empty string)
 * @returns {Array}
 */
if (!Array.prototype.clean) {
    Object.defineProperty(Array.prototype, 'clean', {
        value: function (deleteValue) {
            if (!is_defined(deleteValue)) {
                deleteValue = '';
            }
            for (var i = 0; i < this.length; i++) {
                if (this[i] == deleteValue) {
                    this.splice(i, 1);
                    i--;
                }
            }
            return this;
        },
        enumerable: false
    });
}